// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconDiamondExclamation = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M57.2281 29.7711C55.3978 27.0949 52.1724 22.8485 46.6619 17.3381C41.266 11.9422 37.4717 9.01557 34.2656 6.7934C32.7535 5.74524 31.2898 5.73316 29.7711 6.77179C27.095 8.60218 22.8485 11.8277 17.3381 17.3381C11.9421 22.734 9.01561 26.5283 6.79345 29.7343C5.74523 31.2464 5.73314 32.7102 6.77184 34.2289C8.60216 36.905 11.8276 41.1514 17.3381 46.6619C22.734 52.0578 26.5283 54.9844 29.7344 57.2066C31.2465 58.2548 32.7102 58.2668 34.2289 57.2282C36.905 55.3978 41.1515 52.1723 46.6619 46.6619C52.0578 41.266 54.9844 37.4717 57.2065 34.2657C58.2547 32.7535 58.2668 31.2897 57.2281 29.7711ZM29.7505 18H34.2495C35.3516 18 36.0251 18.7046 35.9993 19.8063C35.8442 26.4256 34.8694 30.9203 34.3481 32.8825C34.1523 33.6195 33.66 34 32.8973 34H31.1027C30.34 34 29.8476 33.6195 29.6518 32.8825C29.1306 30.9203 28.1558 26.4256 28.0007 19.8063C27.9748 18.7046 28.6484 18 29.7505 18ZM32 46C29.5317 46 28 44.4681 28 42C28 39.5318 29.5317 38 32 38C34.4683 38 36 39.5318 36 42C36 44.4681 34.4683 46 32 46Z" />
    </svg>
  );
};
